import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20gaming%20world%20landscape%2C%20warm%20amber%20and%20golden%20geometric%20shapes%20floating%2C%20stylized%20video%20game%20controller%20silhouette%2C%20digital%20art%20with%20organic%20flowing%20lines%2C%20dreamy%20atmospheric%20lighting%2C%20clean%20minimal%20composition%2C%20warm%20color%20palette%20with%20terracotta%20accents&width=1800&height=1200&seq=hero-bg-gaming&orientation=landscape"
          alt="黄油游戏库 - 独立游戏世界"
          title="黄油游戏库 - 精选独立游戏一站式畅玩平台"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="animate-fade-in-up">
            <span className="inline-block px-4 py-1.5 bg-primary-500/90 text-background-50 text-sm font-medium rounded-full mb-6">
              精选独立游戏一站式畅玩平台
            </span>
          </div>
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading text-background-50 mb-6 leading-tight animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
            探索属于你的
            <span className="text-primary-300">游戏世界</span>
          </h1>
          <p className="text-base md:text-lg text-background-200/90 max-w-2xl mx-auto mb-10 leading-relaxed animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            汇聚海量高质量独立游戏资源，支持一键下载、云端存档与社区互动。
            无论你是休闲玩家还是硬核玩家，都能在这里找到属于你的游戏天地。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
            <Link
              to="/category/action-adventure"
              className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              立即探索游戏
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 bg-background-50/15 text-background-50 backdrop-blur-sm rounded-full text-base font-semibold hover:bg-background-50/25 transition-all duration-300 border border-background-50/20 whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>

          <div className="mt-16 grid grid-cols-2 sm:grid-cols-4 gap-6 max-w-2xl mx-auto animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
            {[
              { value: '2000+', label: '精选游戏' },
              { value: '50万+', label: '活跃玩家' },
              { value: '4.8', label: '用户评分' },
              { value: '99.9%', label: '服务可用率' },
            ].map((stat, i) => (
              <div key={i} className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-background-50">{stat.value}</div>
                <div className="text-xs md:text-sm text-background-300 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>

          <div className="mt-12 animate-bounce">
            <div className="w-8 h-8 mx-auto flex items-center justify-center">
              <i className="ri-arrow-down-line text-background-300 text-xl"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}